import { createAsyncThunk } from "@reduxjs/toolkit";
import { getNews } from "../../api/request/dashboard/dashboard";

export const fetchNews = createAsyncThunk('news/get', async (_, { }) => {
    try {
        const { data } = await getNews();
        return data;
    } catch (err) {
        return []
    }
})